import Config from '../config';

const tokensReducer = (state = Config.tokensDefault, action) => {
    if (action.type === 'SET_TOKENS') {
        return {
            ...state,
            token: action.tokens.token,
            // Seconds the browser clock is ahead of the server (keycloak-js timeSkew)
            timeSkew: action.tokens.timeSkew ?? 0
        }
    }
    return state;
};

export default tokensReducer;